import { Alert, Button, VStack } from '@chakra-ui/react';
import { sendAnalyticsEvent } from '../common/libs/googleAnalytics';
import useIdApiClient from '../hooks/useIdApiClient';

type Props = { gaLabelKey?: string; accountType?: 'doctor' | 'student' };

const NeedLicenseVerify: React.FC<Props> = ({ gaLabelKey, accountType }) => {
  const { proceedIdPage } = useIdApiClient();

  const doctorRegister = async () => {
    if (gaLabelKey) {
      // prettier-ignore
      sendAnalyticsEvent('induction', 'doctor_certification', `need_verify_${gaLabelKey}`);
    }
    await proceedIdPage(`/users/doctor/register?from_service=slide`);
  };

  const accountTypeString =
    accountType === 'doctor'
      ? '医師'
      : accountType === 'student'
      ? '医学生'
      : '医師/医学生';

  return (
    <VStack w="100%">
      <Alert status="info" justifyContent="center" borderRadius="md" py={10}>
        ご利用いただくには{accountTypeString}認証が必要です。
      </Alert>
      <Button colorScheme="brand" size="lg" mt={4} onClick={doctorRegister}>
        {accountTypeString}認証を行う
      </Button>
    </VStack>
  );
};

export default NeedLicenseVerify;
